import { useAppNavigate } from "../../../hooks/useAppNavigate";
import { BellContainer, UnreadBadge } from "./NotificationBell.styles";
import { useNotifications } from "../../../hooks/queries/useNotifications";
import { useTranslation } from "react-i18next";

const BellIcon = () => (
  <svg
    width="1.25rem"
    height="1.25rem"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  </svg>
);

export const NotificationBell = ({ showLabel }: { showLabel?: boolean }) => {
  const navigate = useAppNavigate();
  const { data: notifications } = useNotifications();
  const { t } = useTranslation(["nav"]);

  const unreadCount = notifications?.filter((n) => !n.isRead).length || 0;

  return (
    <BellContainer
      $showLabel={showLabel}
      onClick={() => navigate("notifications")}
      title="Notifications"
    >
      <BellIcon />
      {showLabel && (
        <span
          style={{
            marginLeft: "0.5rem",
            fontWeight: 600,
            fontSize: "0.875rem",
          }}
        >
          {t("nav:notifications", "Notifications")}
        </span>
      )}
      {unreadCount > 0 && (
        <UnreadBadge>{unreadCount > 99 ? "99+" : unreadCount}</UnreadBadge>
      )}
    </BellContainer>
  );
};
